var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.a00ae3889e9a3632b3c6e219e715d304.svg#DarkHelmet--fr5Ig';
                    var viewUrl = 'sprites.a00ae3889e9a3632b3c6e219e715d304.svg#view-DarkHelmet--fr5Ig';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 22 20',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };